import * as JSZip from 'jszip';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const FileSaver = require('file-saver');

enum AccordionStatus {
  COLLAPSED = 'collapsed',
  EXPANDED = 'expanded',
}

export default class Brochures {
  private readonly brochuresAccordion: HTMLElement | null;

  private readonly accordionBody: HTMLElement | null;

  private readonly downloadAll: HTMLElement | null;

  private readonly expandIcon: HTMLElement | null;

  constructor() {
    this.brochuresAccordion = document.getElementById('brochures-accordion');
    this.accordionBody = document.querySelector('div[data-accordionbody="true"]') as HTMLElement;
    this.downloadAll = document.getElementById('download-all-brochures');
    this.expandIcon = document.getElementById('expand-icon');
  }

  public setupEventListeners = () => {
    if (this.brochuresAccordion) this.brochuresAccordion.addEventListener('click', this.toggleAccordion);
    if (this.downloadAll) this.downloadAll.addEventListener('click', this.downloadAllBrochures);
  };

  private toggleAccordion = () => {
    const accordionStatus = this.brochuresAccordion?.dataset.accordionstatus as AccordionStatus;
    if (accordionStatus === AccordionStatus.COLLAPSED) this.expandAccordion();
    if (accordionStatus === AccordionStatus.EXPANDED) this.collapseAccordion();
  };

  private expandAccordion = () => {
    if (this.accordionBody) this.accordionBody.style.display = 'block';
    if (this.brochuresAccordion) this.brochuresAccordion.dataset.accordionstatus = AccordionStatus.EXPANDED;
    if (this.expandIcon) this.expandIcon.style.transform = 'rotate(180deg)';
  };

  private collapseAccordion = () => {
    if (this.accordionBody) this.accordionBody.style.display = 'none';
    if (this.brochuresAccordion) this.brochuresAccordion.dataset.accordionstatus = AccordionStatus.COLLAPSED;
    if (this.expandIcon) this.expandIcon.style.transform = 'rotate(0deg)';
  };

  private downloadAllBrochures = async () => {
    const brochures = this.brochuresAccordion?.dataset.brochuresurls?.split(',') as Array<string>;
    this.downloadMany(brochures).then(this.downloadZipFile);
  };

  private download = (url: string) => fetch(url).then((brochures) => brochures.blob());

  private downloadMany = (urls: Array<string>) => Promise.all(urls.map((url) => this.download(url)));

  private downloadZipFile = (blobs: Array<Blob>) => {
    const zip = JSZip();
    blobs.forEach((blob, index) => {
      zip.file(`brochure-${index}.pdf`, blob);
    });
    zip.generateAsync({ type: 'blob' }).then((zipFile) => {
      const currentDate = new Date().getTime();
      const fileName = `brochures-${currentDate}.zip`;
      return FileSaver.saveAs(zipFile, fileName);
    });
  };
}
